export function htmlToElement(html) {
    const template = document.createElement('template');
    html = html.trim(); // Never return a text node of whitespace as the result
    template.innerHTML = html;
    return template.content.firstChild;
}

export function show(element, display = undefined) {

    if (display) {
        element.style.display = display;
        return;
    }

    const dataDisplay = element.getAttribute('data-display');

    if (dataDisplay !== undefined) {
        element.style.display = dataDisplay;
        return;
    }

    element.style.display = 'block';
}

export function hide(element) {
    if (element.style.display !== 'none') {
        element.setAttribute('data-display', element.style.display);
    }
    element.style.display = 'none';
}

export function executeFirstTimeIsVisible(element, fn) {
    const options = {
        rootMargin: '100px',
        threshold: 0
    };

    const observer = new IntersectionObserver(
         (entries, self) => {

             for(let i = 0; i < entries.length; i < i++) {
                 if (entries[i].isIntersecting) {
                     try {
                         fn();
                     } catch (e) {
                         throw e;
                     } finally {
                         self.unobserve(element);
                     }
                     return;
                 }
             }

        },
        options
    );

    observer.observe(element);
}